import { useEffect, useRef } from 'react';

export default function ManifestoSection() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.reveal-on-scroll').forEach((el) => {
              el.classList.add('revealed');
            });
          }
        });
      },
      { threshold: 0.15 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} id="manifesto" className="relative py-24 md:py-36 px-6 md:px-10" style={{ backgroundColor: 'oklch(var(--background-100))' }}>
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          {/* Left Column - Images */}
          <div className="relative reveal-on-scroll order-2 lg:order-1">
            <div className="relative">
              {/* Main Image */}
              <div className="relative overflow-hidden rounded-lg w-full" style={{ aspectRatio: '3/4' }}>
                <img
                  src="https://static.readdy.ai/image/e52027607460cffc32b49812e98784ba/a660e0886c08baa12b1d9c12c45338fa.jpeg"
                  alt="Noiva elegante em ensaio editorial com luz natural suave"
                  title="Noiva Premium - The Future Wedding Ribeirão Preto"
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Overlapping smaller image */}
              <div
                className="absolute -bottom-10 -right-6 md:-right-10 w-48 md:w-64 rounded-lg overflow-hidden"
                style={{ aspectRatio: '4/5' }}
              >
                <img
                  src="https://static.readdy.ai/image/e52027607460cffc32b49812e98784ba/51e77d6dc7153955e07dfee6dd5555bb.jpeg"
                  alt="Detalhes luxuosos de casamento com taças e flores"
                  title="Detalhes Premium - The Future Wedding"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>

          {/* Right Column - Text */}
          <div className="reveal-on-scroll order-1 lg:order-2">
            <p className="text-xs tracking-[0.25em] uppercase mb-6" style={{ color: 'oklch(var(--secondary-500))' }}>
              O Manifesto
            </p>

            <h2
              className="font-heading text-3xl md:text-4xl lg:text-5xl leading-[1.15] mb-8"
              style={{ color: 'oklch(var(--foreground-900))' }}
            >
              O casamento não começa
              <br />
              no altar.
            </h2>

            <div className="space-y-5">
              <p className="text-sm md:text-base leading-relaxed" style={{ color: 'oklch(var(--foreground-600))' }}>
                Ele começa nas conversas.
                <br />
                Nas escolhas.
                <br />
                Nas dúvidas.
                <br />
                Nos sonhos.
              </p>
              <p className="text-sm md:text-base leading-relaxed" style={{ color: 'oklch(var(--foreground-600))' }}>
                E principalmente na forma como você decide construir essa experiência.
                O The Future Wedding nasceu para transformar inspiração em direção.
              </p>
              <p className="text-sm md:text-base leading-relaxed font-medium" style={{ color: 'oklch(var(--primary-500))' }}>
                Porque um casamento bonito é consequência.
                <br />
                Um casamento com significado é uma escolha.
              </p>
            </div>

            <div className="mt-8 divider-accent"></div>

            <div className="mt-8 grid grid-cols-3 gap-6">
              <div className="text-center">
                <p className="font-heading text-3xl md:text-4xl mb-1" style={{ color: 'oklch(var(--primary-500))' }}>02</p>
                <p className="text-[10px] tracking-[0.15em] uppercase" style={{ color: 'oklch(var(--foreground-500))' }}>dias de Imersão</p>
              </div>
              <div className="text-center">
                <p className="font-heading text-3xl md:text-4xl mb-1" style={{ color: 'oklch(var(--primary-500))' }}>80</p>
                <p className="text-[10px] tracking-[0.15em] uppercase" style={{ color: 'oklch(var(--foreground-500))' }}>Vagas Totais</p>
              </div>
              <div className="text-center">
                <p className="font-heading text-3xl md:text-4xl mb-1" style={{ color: 'oklch(var(--primary-500))' }}>EXC</p>
                <p className="text-[10px] tracking-[0.15em] uppercase" style={{ color: 'oklch(var(--foreground-500))' }}>experiência Exclusiva</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}